import ResultadoConsulta from "../Contenedores/ResultadoConsulta";
import { apiConsultaReporte } from "../Utils/constantes";
import { trackPromise } from "react-promise-tracker";
import Http from "./Http";

export const ObtengaReporteCrediticio = async () => {
    const salida = new ResultadoConsulta();
    const url = apiConsultaReporte;
   
    const respuesta = await trackPromise (Http.get(url));
    salida.ReporteHtml = respuesta.data.reporteHtml;
    salida.Errores = respuesta.data.errores;
    salida.EsValido = respuesta.data.esValido;
    
    return salida;
}